import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#3AE8CF",
        d: "M31.1098 39.389c0 .7899-.5079 1.4671-1.185 1.6363-1.58.395-3.7241.7336-5.9812.7336-2.3135 0-4.2884-.3386-5.8684-.7336-.6771-.1692-1.1849-.8464-1.1849-1.6363v-6.0941h14.2195z"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#23C9B1",
        d: "m10.1755 20.6553 6.7711 12.8087c1.9185.5079 4.3449.79 7.0533.9029 3.4985.1128 5.5863-.2822 7.1098-.9029-.0564.0565 6.6583-12.7523 6.6583-12.7523z"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#28A08E",
        d: "m6.395 13.2636 3.837 7.4483c3.047.8464 9.5925 2.0313 14.1066 2.1442 4.4012.0564 11.1724-1.1286 13.373-2.0878 0 0 3.047-5.9248 4.0063-7.7868.1128-.2257-.0564-.5079-.2821-.5079l-34.815.2257c-.2258 0-.395.3386-.2258.5643"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#007A71",
        d: "M24 17.3824c9.9411 0 18-2.3242 18-5.1912S33.9411 7 24 7 6 9.3242 6 12.1912s8.0589 5.1912 18 5.1912"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#004743",
        d: "M25.9749 31.6015c-.395.1693-.8464.2822-1.2978.2822s-.9028-.0564-1.2414-.2257q-.5924-.254-1.0157-.6771c-.2821-.2822-.5078-.6772-.6771-1.0722-.1693-.3949-.2257-.9028-.2257-1.3542 0-.5078.0564-.9592.2257-1.4106s.395-.79.6771-1.0721q.4232-.4233 1.0157-.6772c.395-.1692.79-.2257 1.2414-.2257.395 0 .8464.0565 1.2414.2257s.7335.395.9592.6772l-.9592 1.0721c-.1129-.2257-.2822-.3386-.5079-.4515q-.3386-.1692-.6771-.1692t-.6771.1692c-.2257.1129-.395.2257-.5642.395s-.2822.395-.3386.6207-.1129.5078-.1129.79.0565.5643.1129.79.2257.4514.3386.6206c.1692.1693.3385.2822.5078.395q.3385.1693.6771.1693c.2821 0 .5078-.0564.7335-.1693.2257-.1128.395-.2821.5079-.4514l1.0157 1.0157c-.2258.2821-.5643.5642-.9593.7335"
    }, "4")
], "AppConversion", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
